import { NavLink } from "react-router-dom";
import { hexToRgb } from "utils/colors.utils";
import AiAgentMenu from "./AiAgentMenu";

const NavItem = ({
  url,
  to,
  onClick,
  menuTextColor,
  menuTextHoverColor,
  isSubRoute,
  className,
  children,
  action
}) => {
  if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        style={{ color: menuTextColor }}
      >
        {children}
      </a>
    );
  }
  if(action) {
      return (
      <AiAgentMenu
        className={className}
        style={{ color: menuTextColor }}
      >
        {children}
      </AiAgentMenu>
    );
  }

  return (
    <NavLink
      onClick={onClick}
      to={to}
      className={className}
      style={({ isActive }) =>
        isActive
          ? {
              color: menuTextHoverColor,
              background: `${
                !isSubRoute
                  ? `rgba(${hexToRgb(menuTextHoverColor)}, 0.05)`
                  : null
              }`,
            }
          : { color: menuTextColor }
      }
    >
      {children}
    </NavLink>
  );
};

export default NavItem;
